import { setLocale } from "yup";

setLocale({
  mixed: {
    notNull: "validation.required",
    defined: "validation.required",
  },
});
